module.exports = __webpack_public_path__ + "img/74ef75f.svg";